import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import IconEdit from '@material-ui/icons/Edit';

import { ASSET_TYPE } from 'src/data/asset';
import MarkedEditor from 'src/components/MarkedEditor';
import TextCounter from 'src/components/TextCounter';
import { useContentCounterData } from './useContentCounterData';
import { useStyles } from './useStyles';

export const TextEditorGeneric = ({
  className,
  assetType,
  content,
  onChange,
  disabled,
  readOnly,
  marks,
  hideMarks,
  editorRef,
}) => {
  const styles = useStyles();
  const [focused, setFocused] = useState(false);

  const counter = useContentCounterData(assetType, content);

  const handleChange = useCallback(
    (value) => {
      if (onChange) {
        onChange(value);
      }
    },
    [onChange]
  );

  const handleFocusChange = useCallback((value) => {
    setFocused(value);
  }, []);

  return (
    <div
      className={cx(styles.root, className, {
        [styles.focused]: focused,
        [styles.empty]: counter.isEmpty,
        [styles.disabled]: disabled || readOnly,
        [styles.readOnly]: readOnly,
      })}
      data-testid="TextEditor"
    >
      <div className={styles.editorWrapper}>
        <div className={styles.outline} />

        <MarkedEditor
          className={styles.editor}
          ref={editorRef}
          value={content}
          onChange={handleChange}
          onFocusChange={handleFocusChange}
          readOnly={disabled || readOnly}
          marks={marks}
          hideMarks={hideMarks}
          disableChildrenRewrite
        />

        {!readOnly && (
          <div className={styles.footer}>
            <TextCounter
              className={styles.textCounter}
              count={counter.charCount}
              maxCount={counter.maxCount}
              strict={counter.isStrict}
            />

            <IconEdit className={styles.iconEdit} />
          </div>
        )}
      </div>
    </div>
  );
};

TextEditorGeneric.propTypes = {
  className: PropTypes.string,
  assetType: PropTypes.oneOf(Object.values(ASSET_TYPE)).isRequired,
  content: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  marks: PropTypes.arrayOf(PropTypes.shape()),
  hideMarks: PropTypes.bool,
  editorRef: PropTypes.shape(),
};

TextEditorGeneric.defaultProps = {
  className: null,
  onChange: null,
  disabled: false,
  readOnly: false,
  marks: [],
  hideMarks: false,
  editorRef: null,
};
